import { render, staticRenderFns } from "./Signage.vue?vue&type=template&id=1ed5596c&scoped=true&"
import script from "./Signage.vue?vue&type=script&lang=js&"
export * from "./Signage.vue?vue&type=script&lang=js&"
import style0 from "./Signage.vue?vue&type=style&index=0&id=1ed5596c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5596c",
  null
  
)

export default component.exports